import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ErrorMessage, FieldAndLabel, FieldRow, Label } from 'components/common/form-components';
import styled from '@emotion/styled';
import CopyableCodeBlock from 'components/common/copyable-code-block';
import Spinner from 'components/common/spinner';

type OidcClaimFieldProps = {
  labelId: string;
  value?: string;
  loading?: boolean;
  error?: string;
  dataE2e: string;
};

const OidcClaimField: React.FunctionComponent<OidcClaimFieldProps> = ({ labelId, value, loading, error, dataE2e }) => (
  <FieldRow>
    <FieldAndLabel>
      <Label id={labelId} />
      {loading ? (
        <Spinner />
      ) : (
        <ClaimValue inline data-e2e={dataE2e}>
          {value}
        </ClaimValue>
      )}
      <ErrorMessage data-e2e={`${dataE2e}-error`}>{error && <FormattedMessage id={error} />}</ErrorMessage>
    </FieldAndLabel>
  </FieldRow>
);

const ClaimValue = styled(CopyableCodeBlock)`
  align-self: flex-start;
`;

export default OidcClaimField;
